import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 前端页面
 */
const frontEndPage = {
  /**
   * 获取所有前端页面
   */
  getAllFrontEndPages() {
    return axios.post(
      base.frontEndPage.getAllFrontEndPages,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 增加前端页面
   */
  addFrontEndPage(pageName, pagePath) {
    return axios.post(
      base.frontEndPage.addFrontEndPage,
      utils.postParamsArrayToJsonString({ pageName, pagePath })
    );
  },
  /**
   * 修改前端页面
   */
  modifyFrontEndPage(id, pageName, pagePath) {
    return axios.post(
      base.frontEndPage.modifyFrontEndPage,
      utils.postParamsArrayToJsonString({ id, pageName, pagePath })
    );
  },
  /**
   * 删除前端页面
   */
  deleteFrontEndPage(id) {
    return axios.post(
      base.frontEndPage.deleteFrontEndPage,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 设置前端页面包含按钮
   */
  setFrontEndPageContainingButtons(id, buttons) {
    return axios.post(
      base.frontEndPage.setFrontEndPageContainingButtons,
      utils.postParamsArrayToJsonString({ id, buttons })
    );
  },
  /**
   * 获取前端页面包含按钮
   */
  getFrontEndPageContainingButtons(pageId) {
    return axios.post(
      base.frontEndPage.getFrontEndPageContainingButtons,
      utils.postParamsArrayToJsonString({ pageId })
    );
  },
  /**
   * 获取前端页面包含按钮
   */
  getFrontEndPageContainingButtons2(pagePath) {
    return axios.post(
      base.frontEndPage.getFrontEndPageContainingButtons2,
      utils.postParamsArrayToJsonString({ pagePath })
    );
  },
  /**
   * 设置前端页面按钮涉及操作权限
   */
  setFrontEndPageButtonInvolvingOperations(buttonId, operations) {
    return axios.post(
      base.frontEndPage.setFrontEndPageButtonInvolvingOperations,
      utils.postParamsArrayToJsonString({ buttonId, operations })
    );
  },
  /**
   * 获取前端页面按钮涉及操作权限
   */
  getFrontEndPageButtonInvolvingOperations(buttonId) {
    return axios.post(
      base.frontEndPage.getFrontEndPageButtonInvolvingOperations,
      utils.postParamsArrayToJsonString({ buttonId })
    );
  },
  /**
   * 获取前端页面按钮涉及操作权限
   */
  getFrontEndPageButtonInvolvingOperations2() {
    return axios.post(
      base.frontEndPage.getFrontEndPageButtonInvolvingOperations2,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 获取角色页面路径信息
   */
  batchGetRoleFrontEndPageParamCustom(roleId, subSystemId) {
    return axios.post(
      base.frontEndPage.batchGetRoleFrontEndPageParamCustom,
      utils.postParamsArrayToJsonString({ roleId, subSystemId })
    );
  },
  /**
   * 获取公司页面路径信息
   */
  batchGetCompanyFrontEndPageDefaultParamBySubSystem(companyId, subSystemId) {
    return axios.post(
      base.frontEndPage.batchGetCompanyFrontEndPageDefaultParamBySubSystem,
      utils.postParamsArrayToJsonString({ companyId, subSystemId })
    );
  },
  /**
   * 增加角色页面实例
   */
  addRolePageInstance(roleId, pageId, instanceName) {
    return axios.post(
      base.frontEndPage.addRolePageInstance,
      utils.postParamsArrayToJsonString({ roleId, pageId, instanceName })
    );
  },
  /**
   * 删除角色页面实例
   */
  deleteRolePageInstance(roleId, pageId, instanceName) {
    return axios.post(
      base.frontEndPage.deleteRolePageInstance,
      utils.postParamsArrayToJsonString({ roleId, pageId, instanceName })
    );
  },
  /**
   * 增加公司页面实例
   */
  addCompanyIdPageInstance(companyId, pageId, instanceName) {
    return axios.post(
      base.frontEndPage.addCompanyIdPageInstance,
      utils.postParamsArrayToJsonString({ companyId, pageId, instanceName })
    );
  },
  /**
   * 删除公司页面实例
   */
  deleteCompanyIdPageInstance(companyId, pageId, instanceName) {
    return axios.post(
      base.frontEndPage.deleteCompanyIdPageInstance,
      utils.postParamsArrayToJsonString({ companyId, pageId, instanceName })
    );
  },
};

export default frontEndPage;
